import { Pipe, PipeTransform } from '@angular/core';
import { isDefined } from '@evorait/pace-core';
import { AnswerStatus } from '../../types/answer-status';
import { CHECKPOINTS_STATUS } from '../../types/checkpoints-status';
import { StatusUtilities } from '../../utilities/status-utilities';

@Pipe({
    name: 'statusIcon',
    standalone: false,
})
export class StatusIconPipe implements PipeTransform {
    public transform(value: AnswerStatus | undefined | null): CHECKPOINTS_STATUS {
        if (!isDefined(value)) {
            return CHECKPOINTS_STATUS.NONE;
        }
        return StatusUtilities.getCheckpointStatusFromAnswers(value);
    }
}
